export const navigationBarData=[
{
	text:"Home",
	className:"home",
	path:"/"
},
{
	text:"List crypto",
	className:"list_crypto",
	path:"/list_crypto"
},
{
	text:"Find crypto",
	className:"find_crypto",
	path:"/find_crypto"
}];